const SarIcon = ({color='#334155', width=41, height=44,pathURL='clip0_448_7937'}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 41 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block ms-[3px]">
            <g clip-path={`url(#${pathURL})`}>
                <path d="M25.5167 38.9806C24.7851 40.5383 24.3015 42.2288 24.1162 44.0016L39.5991 40.8413C40.3307 39.2839 40.814 37.5931 40.9996 35.8203L25.5167 38.9806Z" fill={color}/>
                <path d="M39.5995 31.3718C40.3311 29.8144 40.8147 28.1236 41 26.3508L28.9393 28.8139V24.079L39.5991 21.9039C40.3307 20.3465 40.8144 18.6557 40.9996 16.8829L28.939 19.3438V2.31594C27.0909 3.31228 25.4497 4.63853 24.1155 6.20292V20.3286L19.292 21.3131V0C17.444 0.995997 15.8027 2.32259 14.4686 3.88698V22.2972L3.67605 24.4993C2.94441 26.0567 2.46042 27.7475 2.27478 29.5202L14.4686 27.032V32.9947L1.40054 35.6612C0.668902 37.2185 0.185279 38.9094 0 40.6821L13.6786 37.8909C14.7921 37.6686 15.7491 37.0364 16.3713 36.1665L18.8799 32.5954V32.5947C19.1403 32.2253 19.292 31.7798 19.292 31.3V26.0476L24.1155 25.0631V34.5328L39.5991 31.3711L39.5995 31.3718Z" fill={color}/>
            </g>
            <defs>
                <clipPath id={pathURL}>
                    <rect width={width} height={height} fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default SarIcon;